import { Menu, Search } from 'lucide-react';
import type { Session } from '@supabase/supabase-js';

import { Breadcrumbs } from './Breadcrumbs';
import { NotificationBell } from './NotificationBell';
import { UserMenu } from './UserMenu';
import styles from './TopBar.module.css';

interface Props {
  session: Session;
  fullName: string | null;
  role: string | null;
  onSidebarToggle: () => void;
  onPaletteOpen: () => void;
}

export function TopBar({ session, fullName, role, onSidebarToggle, onPaletteOpen }: Props) {
  return (
    <header className={styles.topbar}>
      <button
        type="button"
        className={styles.toggle}
        onClick={onSidebarToggle}
        aria-label="פתח או סגור תפריט"
      >
        <Menu size={18} />
      </button>

      <Breadcrumbs />

      <div className={styles.spacer} />

      <button
        type="button"
        className={styles.searchBtn}
        onClick={onPaletteOpen}
        aria-label="פתח חיפוש"
      >
        <Search size={16} />
        <span className={styles.searchPlaceholder}>חיפוש</span>
        <span className={styles.kbd}>Ctrl+K</span>
      </button>

      <NotificationBell />

      <UserMenu session={session} fullName={fullName} role={role} />
    </header>
  );
}
